import { AuthApi } from "api/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetAuth, selectToken, selectUsername } from "store/auth";
import { resetBank } from "store/bank";
import { resetDeposit } from "store/deposit";
import { resetUser } from "store/user";

import { useAppDispatch, useAppSelector } from "./app-hook";

export const useVerify = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const token = useAppSelector(selectToken) || localStorage.getItem("token");
  const username =
    useAppSelector(selectUsername) || localStorage.getItem("username");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchVerifyToken = useCallback(async () => {
    if (!token || !username) {
      navigate("/login");
      return;
    }

    const res = await AuthApi.verifyToken(username, {
      token,
      username,
    });
    setIsLoading(false);
    if (res.msg === "Success") return;

    dispatch(resetAuth());
    dispatch(resetBank());
    dispatch(resetDeposit());
    dispatch(resetUser());
    localStorage.clear();
    navigate("/login");
  }, [token, username]);

  useEffect(() => {
    fetchVerifyToken();
  }, [location.pathname, fetchVerifyToken]);

  return { isLoading };
};
